/**
 * نگاشت ماژول‌های UI به کلیدهای modules در پاسخ لاگین
 */
export const MENU_MODULE_ALIASES = {
  finance: ['payments', 'expenses', 'bankaccount', 'estimates', 'invoices'],
  hr: ['employees', 'attendance', 'leaves', 'holidays', 'shift'],
  'dashboard-module': ['reports', 'dashboards'],
  'call-center': ['callcenter'],
  work: ['projects', 'tasks', 'contracts', 'timelogs'],
};

/** مسیر → ماژول فعال شرکت */
export const ROUTE_MODULE_MAP = {
  '/dashboard': null,
  '/dashboard/private': null,
  '/dashboard/advanced': null,
  '/leads': 'leads',
  '/leads/deals': 'leads',
  '/deals': 'leads',
  '/clients': 'clients',
  '/products': 'products',
  '/orders': 'orders',
  '/tickets': 'tickets',
  '/call-center': 'callcenter',
  '/call-center/calls': 'callcenter',
  '/call-center/agents': 'callcenter',
  '/call-center/settings': 'callcenter',
  '/call-center/blacklist': 'callcenter',
  '/call-center/reports': 'callcenter',
  '/notices': 'notices',
  '/messages': 'messages',
  '/calendar': 'events',
  '/finance': 'payments',
  '/finance/bank-accounts': 'bankaccount',
  '/finance/expenses': 'expenses',
  '/finance/recurring-expenses': 'expenses',
  '/finance/estimates': 'estimates',
  '/finance/invoices': 'invoices',
  '/hr': 'employees',
  '/hr/dashboard': 'employees',
  '/hr/employees': 'employees',
  '/hr/leaves': 'leaves',
  '/hr/attendance': 'attendance',
  '/hr/attendance-regularizations': 'attendance',
  '/hr/attendance-adjustments': 'attendance',
  '/hr/overtime-requests': 'attendance',
  '/hr/attendance-missions': 'attendance',
  '/workflow/inbox': null,
  '/hr/shifts': 'shift',
  '/hr/holidays': 'holidays',
  '/hr/departments': 'employees',
  '/hr/positions': 'employees',
  '/hr/leaves-settings': 'leaves',
  '/hr/attendance-settings': 'attendance',
  '/reports': 'reports',
  '/work': null,
  '/work/tasks': 'tasks',
  '/work/projects': 'projects',
  '/work/contracts': 'contracts',
  '/settings': null,
  '/action': null,
};

/**
 * نگاشت نام پرمیشن (slug بک‌اند) → resource + action در پاسخ API
 * پوشش ماژول‌های فعال پنل بر اساس ERP_Karmad_Modules_Permissions_AccessControl.pdf
 */
export const LEGACY_PERMISSION_MAP = {
  add_appreciation: { resource: 'employees', action: 'add' },
  add_attendance: { resource: 'attendance', action: 'add' },
  add_bank_deposit: { resource: 'bankaccount', action: 'add' },
  add_bank_transfer: { resource: 'bankaccount', action: 'add' },
  add_bank_withdraw: { resource: 'bankaccount', action: 'add' },
  add_bankaccount: { resource: 'bankaccount', action: 'add' },
  add_client_contacts: { resource: 'clients', action: 'add' },
  add_client_document: { resource: 'clients', action: 'add' },
  add_client_note: { resource: 'clients', action: 'add' },
  add_clients: { resource: 'clients', action: 'add' },
  add_contract: { resource: 'contracts', action: 'add' },
  add_contract_discussion: { resource: 'contracts', action: 'add' },
  add_contract_files: { resource: 'contracts', action: 'add' },
  add_deal: { resource: 'leads', action: 'add' },
  add_deal_note: { resource: 'leads', action: 'add' },
  add_deal_pipeline: { resource: 'leads', action: 'add' },
  add_deals: { resource: 'leads', action: 'add' },
  add_department: { resource: 'employees', action: 'add' },
  add_designation: { resource: 'employees', action: 'add' },
  add_documents: { resource: 'employees', action: 'add' },
  add_employees: { resource: 'employees', action: 'add' },
  add_estimate: { resource: 'estimates', action: 'add' },
  add_estimate_request: { resource: 'estimates', action: 'add' },
  add_estimates: { resource: 'estimates', action: 'add' },
  add_events: { resource: 'events', action: 'add' },
  add_expense: { resource: 'expenses', action: 'add' },
  add_expenses: { resource: 'expenses', action: 'add' },
  add_holiday: { resource: 'holidays', action: 'add' },
  add_immigration: { resource: 'employees', action: 'add' },
  add_invoices: { resource: 'invoices', action: 'add' },
  add_lead: { resource: 'leads', action: 'add' },
  add_lead_agent: { resource: 'leads', action: 'add' },
  add_lead_category: { resource: 'leads', action: 'add' },
  add_lead_files: { resource: 'leads', action: 'add' },
  add_lead_follow_up: { resource: 'leads', action: 'add' },
  add_lead_note: { resource: 'leads', action: 'add' },
  add_lead_proposals: { resource: 'leads', action: 'add' },
  add_lead_sources: { resource: 'leads', action: 'add' },
  add_leave: { resource: 'leaves', action: 'add' },
  add_message: { resource: 'messages', action: 'add' },
  add_notice: { resource: 'notices', action: 'add' },
  add_order: { resource: 'orders', action: 'add' },
  add_payments: { resource: 'payments', action: 'add' },
  add_product: { resource: 'products', action: 'add' },
  add_project: { resource: 'projects', action: 'add' },
  add_project_discussions: { resource: 'projects', action: 'add' },
  add_project_files: { resource: 'projects', action: 'add' },
  add_project_members: { resource: 'projects', action: 'add' },
  add_project_milestones: { resource: 'projects', action: 'add' },
  add_project_note: { resource: 'projects', action: 'add' },
  add_project_rating: { resource: 'projects', action: 'add' },
  add_projects: { resource: 'projects', action: 'add' },
  add_status: { resource: 'tasks', action: 'add' },
  add_sub_tasks: { resource: 'tasks', action: 'add' },
  add_task: { resource: 'tasks', action: 'add' },
  add_task_category: { resource: 'tasks', action: 'add' },
  add_task_comments: { resource: 'tasks', action: 'add' },
  add_task_files: { resource: 'tasks', action: 'add' },
  add_task_notes: { resource: 'tasks', action: 'add' },
  add_tasks: { resource: 'tasks', action: 'add' },
  add_tickets: { resource: 'tickets', action: 'add' },
  add_timelogs: { resource: 'tasks', action: 'add' },
  approve_expenses: { resource: 'expenses', action: 'edit' },
  approve_or_reject_leaves: { resource: 'leaves', action: 'edit' },
  approve_timelogs: { resource: 'tasks', action: 'edit' },
  change_deal_stages: { resource: 'leads', action: 'edit' },
  change_employee_role: { resource: 'employees', action: 'edit' },
  change_status: { resource: 'tasks', action: 'edit' },
  click_to_call: { resource: 'callcenter', action: 'add' },
  create_public_project: { resource: 'projects', action: 'add' },
  create_unassigned_tasks: { resource: 'tasks', action: 'add' },
  delete_appreciation: { resource: 'employees', action: 'delete' },
  delete_approve_leaves: { resource: 'leaves', action: 'delete' },
  delete_attendance: { resource: 'attendance', action: 'delete' },
  delete_bankaccount: { resource: 'bankaccount', action: 'delete' },
  delete_client_contacts: { resource: 'clients', action: 'delete' },
  delete_client_document: { resource: 'clients', action: 'delete' },
  delete_client_note: { resource: 'clients', action: 'delete' },
  delete_clients: { resource: 'clients', action: 'delete' },
  delete_contract: { resource: 'contracts', action: 'delete' },
  delete_contract_discussion: { resource: 'contracts', action: 'delete' },
  delete_contract_files: { resource: 'contracts', action: 'delete' },
  delete_deal: { resource: 'leads', action: 'delete' },
  delete_deal_note: { resource: 'leads', action: 'delete' },
  delete_deal_pipeline: { resource: 'leads', action: 'delete' },
  delete_deals: { resource: 'leads', action: 'delete' },
  delete_department: { resource: 'employees', action: 'delete' },
  delete_designation: { resource: 'employees', action: 'delete' },
  delete_documents: { resource: 'employees', action: 'delete' },
  delete_employees: { resource: 'employees', action: 'delete' },
  delete_estimate: { resource: 'estimates', action: 'delete' },
  delete_estimate_request: { resource: 'estimates', action: 'delete' },
  delete_estimates: { resource: 'estimates', action: 'delete' },
  delete_events: { resource: 'events', action: 'delete' },
  delete_expense: { resource: 'expenses', action: 'delete' },
  delete_expenses: { resource: 'expenses', action: 'delete' },
  delete_holiday: { resource: 'holidays', action: 'delete' },
  delete_immigration: { resource: 'employees', action: 'delete' },
  delete_invoice: { resource: 'invoices', action: 'delete' },
  delete_invoices: { resource: 'invoices', action: 'delete' },
  delete_lead: { resource: 'leads', action: 'delete' },
  delete_lead_agent: { resource: 'leads', action: 'delete' },
  delete_lead_category: { resource: 'leads', action: 'delete' },
  delete_lead_files: { resource: 'leads', action: 'delete' },
  delete_lead_follow_up: { resource: 'leads', action: 'delete' },
  delete_lead_note: { resource: 'leads', action: 'delete' },
  delete_lead_proposals: { resource: 'leads', action: 'delete' },
  delete_lead_sources: { resource: 'leads', action: 'delete' },
  delete_leave: { resource: 'leaves', action: 'delete' },
  delete_message: { resource: 'messages', action: 'delete' },
  delete_notice: { resource: 'notices', action: 'delete' },
  delete_order: { resource: 'orders', action: 'delete' },
  delete_payments: { resource: 'payments', action: 'delete' },
  delete_product: { resource: 'products', action: 'delete' },
  delete_project: { resource: 'projects', action: 'delete' },
  delete_project_discussions: { resource: 'projects', action: 'delete' },
  delete_project_files: { resource: 'projects', action: 'delete' },
  delete_project_members: { resource: 'projects', action: 'delete' },
  delete_project_milestones: { resource: 'projects', action: 'delete' },
  delete_project_note: { resource: 'projects', action: 'delete' },
  delete_project_rating: { resource: 'projects', action: 'delete' },
  delete_projects: { resource: 'projects', action: 'delete' },
  delete_sub_tasks: { resource: 'tasks', action: 'delete' },
  delete_task: { resource: 'tasks', action: 'delete' },
  delete_task_category: { resource: 'tasks', action: 'delete' },
  delete_task_comments: { resource: 'tasks', action: 'delete' },
  delete_task_files: { resource: 'tasks', action: 'delete' },
  delete_task_notes: { resource: 'tasks', action: 'delete' },
  delete_tasks: { resource: 'tasks', action: 'delete' },
  delete_tickets: { resource: 'tickets', action: 'delete' },
  delete_timelogs: { resource: 'tasks', action: 'delete' },
  edit_appreciation: { resource: 'employees', action: 'edit' },
  edit_attendance: { resource: 'attendance', action: 'edit' },
  edit_bankaccount: { resource: 'bankaccount', action: 'edit' },
  edit_client_contacts: { resource: 'clients', action: 'edit' },
  edit_client_document: { resource: 'clients', action: 'edit' },
  edit_client_note: { resource: 'clients', action: 'edit' },
  edit_clients: { resource: 'clients', action: 'edit' },
  edit_contract: { resource: 'contracts', action: 'edit' },
  edit_contract_discussion: { resource: 'contracts', action: 'edit' },
  edit_deal: { resource: 'leads', action: 'edit' },
  edit_deal_note: { resource: 'leads', action: 'edit' },
  edit_deal_pipeline: { resource: 'leads', action: 'edit' },
  edit_deals: { resource: 'leads', action: 'edit' },
  edit_department: { resource: 'employees', action: 'edit' },
  edit_designation: { resource: 'employees', action: 'edit' },
  edit_documents: { resource: 'employees', action: 'edit' },
  edit_employees: { resource: 'employees', action: 'edit' },
  edit_estimate: { resource: 'estimates', action: 'edit' },
  edit_estimate_request: { resource: 'estimates', action: 'edit' },
  edit_estimates: { resource: 'estimates', action: 'edit' },
  edit_events: { resource: 'events', action: 'edit' },
  edit_expense: { resource: 'expenses', action: 'edit' },
  edit_expenses: { resource: 'expenses', action: 'edit' },
  edit_holiday: { resource: 'holidays', action: 'edit' },
  edit_immigration: { resource: 'employees', action: 'edit' },
  edit_invoice: { resource: 'invoices', action: 'edit' },
  edit_invoices: { resource: 'invoices', action: 'edit' },
  edit_lead: { resource: 'leads', action: 'edit' },
  edit_lead_agent: { resource: 'leads', action: 'edit' },
  edit_lead_category: { resource: 'leads', action: 'edit' },
  edit_lead_follow_up: { resource: 'leads', action: 'edit' },
  edit_lead_note: { resource: 'leads', action: 'edit' },
  edit_lead_proposals: { resource: 'leads', action: 'edit' },
  edit_lead_sources: { resource: 'leads', action: 'edit' },
  edit_leave: { resource: 'leaves', action: 'edit' },
  edit_message: { resource: 'messages', action: 'edit' },
  edit_notice: { resource: 'notices', action: 'edit' },
  edit_order: { resource: 'orders', action: 'edit' },
  edit_payments: { resource: 'payments', action: 'edit' },
  edit_product: { resource: 'products', action: 'edit' },
  edit_project: { resource: 'projects', action: 'edit' },
  edit_project_discussions: { resource: 'projects', action: 'edit' },
  edit_project_members: { resource: 'projects', action: 'edit' },
  edit_project_milestones: { resource: 'projects', action: 'edit' },
  edit_project_note: { resource: 'projects', action: 'edit' },
  edit_project_rating: { resource: 'projects', action: 'edit' },
  edit_projects: { resource: 'projects', action: 'edit' },
  edit_sub_tasks: { resource: 'tasks', action: 'edit' },
  edit_task: { resource: 'tasks', action: 'edit' },
  edit_task_category: { resource: 'tasks', action: 'edit' },
  edit_task_comments: { resource: 'tasks', action: 'edit' },
  edit_task_notes: { resource: 'tasks', action: 'edit' },
  edit_tasks: { resource: 'tasks', action: 'edit' },
  edit_tickets: { resource: 'tickets', action: 'edit' },
  edit_timelogs: { resource: 'tasks', action: 'edit' },
  link_expense_bank_account: { resource: 'expenses', action: 'edit' },
  link_invoice_bank_account: { resource: 'invoices', action: 'edit' },
  link_payment_bank_account: { resource: 'payments', action: 'edit' },
  manage_active_timelogs: { resource: 'tasks', action: 'manage_agent' },
  manage_app_setting: { resource: 'settings', action: 'manage_agent' },
  manage_attendance_setting: { resource: 'attendance', action: 'manage_agent' },
  manage_award: { resource: 'employees', action: 'manage_agent' },
  manage_callcenter_agents: { resource: 'callcenter', action: 'manage_agent' },
  manage_callcenter_blacklist: { resource: 'callcenter', action: 'manage_agent' },
  manage_callcenter_setting: { resource: 'callcenter', action: 'manage_agent' },
  manage_callcenter_settings: { resource: 'callcenter', action: 'manage_agent' },
  manage_client_category: { resource: 'clients', action: 'manage_agent' },
  manage_client_subcategory: { resource: 'clients', action: 'manage_agent' },
  manage_company_setting: { resource: 'settings', action: 'manage_agent' },
  manage_contract_setting: { resource: 'contracts', action: 'manage_agent' },
  manage_contract_template: { resource: 'contracts', action: 'manage_agent' },
  manage_contract_type: { resource: 'contracts', action: 'manage_agent' },
  manage_currency_setting: { resource: 'settings', action: 'manage_agent' },
  manage_custom_field_setting: { resource: 'settings', action: 'manage_agent' },
  manage_custom_link_setting: { resource: 'settings', action: 'manage_agent' },
  manage_deal_stages: { resource: 'leads', action: 'manage_agent' },
  manage_discussion_category: { resource: 'projects', action: 'manage_agent' },
  manage_emergency_contact: { resource: 'employees', action: 'manage_agent' },
  manage_employee_shifts: { resource: 'shift', action: 'manage_agent' },
  manage_expense_category: { resource: 'expenses', action: 'manage_agent' },
  manage_finance_setting: { resource: 'payments', action: 'manage_agent' },
  manage_gdpr_setting: { resource: 'settings', action: 'manage_agent' },
  manage_google_calendar_setting: { resource: 'settings', action: 'manage_agent' },
  manage_increment_promotion: { resource: 'employees', action: 'manage_agent' },
  manage_language_setting: { resource: 'settings', action: 'manage_agent' },
  manage_lead_custom_forms: { resource: 'leads', action: 'manage_agent' },
  manage_lead_setting: { resource: 'leads', action: 'manage_agent' },
  manage_leave_setting: { resource: 'leaves', action: 'manage_agent' },
  manage_message_setting: { resource: 'settings', action: 'manage_agent' },
  manage_module_setting: { resource: 'settings', action: 'manage_agent' },
  manage_notification_setting: { resource: 'settings', action: 'manage_agent' },
  manage_payment_setting: { resource: 'settings', action: 'manage_agent' },
  manage_product_category: { resource: 'products', action: 'manage_agent' },
  manage_product_sub_category: { resource: 'products', action: 'manage_agent' },
  manage_project_category: { resource: 'projects', action: 'manage_agent' },
  manage_project_setting: { resource: 'projects', action: 'manage_agent' },
  manage_project_template: { resource: 'projects', action: 'manage_agent' },
  manage_proposal_template: { resource: 'leads', action: 'manage_agent' },
  manage_recurring_expense: { resource: 'expenses', action: 'manage_agent' },
  manage_recurring_invoice: { resource: 'invoices', action: 'manage_agent' },
  manage_role_permission_setting: { resource: 'settings', action: 'manage_agent' },
  manage_security_setting: { resource: 'settings', action: 'manage_agent' },
  manage_settings: { resource: 'settings', action: 'view' },
  manage_social_login_setting: { resource: 'settings', action: 'manage_agent' },
  manage_storage_setting: { resource: 'settings', action: 'manage_agent' },
  manage_task_setting: { resource: 'tasks', action: 'manage_agent' },
  manage_tax: { resource: 'invoices', action: 'manage_agent' },
  manage_theme_setting: { resource: 'settings', action: 'manage_agent' },
  manage_ticket_agent: { resource: 'tickets', action: 'manage_agent' },
  manage_ticket_channel: { resource: 'tickets', action: 'manage_agent' },
  manage_ticket_groups: { resource: 'tickets', action: 'manage_agent' },
  manage_ticket_setting: { resource: 'tickets', action: 'manage_agent' },
  manage_ticket_tags: { resource: 'tickets', action: 'manage_agent' },
  manage_ticket_type: { resource: 'tickets', action: 'manage_agent' },
  manage_time_log_setting: { resource: 'settings', action: 'manage_agent' },
  reject_estimate_request: { resource: 'estimates', action: 'edit' },
  renew_contract: { resource: 'contracts', action: 'edit' },
  send_reminder: { resource: 'tasks', action: 'edit' },
  task_labels: { resource: 'tasks', action: 'manage_agent' },
  update_leaves_quota: { resource: 'employees', action: 'edit' },
  view_appreciation: { resource: 'employees', action: 'view' },
  view_attendance: { resource: 'attendance', action: 'view' },
  view_attendance_report: { resource: 'reports', action: 'view' },
  view_bankaccount: { resource: 'bankaccount', action: 'view' },
  view_callcenter: { resource: 'callcenter', action: 'view' },
  view_callcenter_reports: { resource: 'callcenter', action: 'view' },
  view_client_contacts: { resource: 'clients', action: 'view' },
  view_client_dashboard: { resource: 'reports', action: 'view' },
  view_client_document: { resource: 'clients', action: 'view' },
  view_client_note: { resource: 'clients', action: 'view' },
  view_clients: { resource: 'clients', action: 'view' },
  view_contract: { resource: 'contracts', action: 'view' },
  view_contract_discussion: { resource: 'contracts', action: 'view' },
  view_contract_files: { resource: 'contracts', action: 'view' },
  view_deal_note: { resource: 'leads', action: 'view' },
  view_deal_pipeline: { resource: 'leads', action: 'view' },
  view_deals: { resource: 'leads', action: 'view' },
  view_department: { resource: 'employees', action: 'view' },
  view_designation: { resource: 'employees', action: 'view' },
  view_documents: { resource: 'employees', action: 'view' },
  view_employee_projects: { resource: 'employees', action: 'view' },
  view_employee_tasks: { resource: 'employees', action: 'view' },
  view_employee_timelogs: { resource: 'employees', action: 'view' },
  view_employees: { resource: 'employees', action: 'view' },
  view_estimate: { resource: 'estimates', action: 'view' },
  view_estimate_request: { resource: 'estimates', action: 'view' },
  view_estimates: { resource: 'estimates', action: 'view' },
  view_events: { resource: 'events', action: 'view' },
  view_expense: { resource: 'expenses', action: 'view' },
  view_expense_report: { resource: 'reports', action: 'view' },
  view_expenses: { resource: 'expenses', action: 'view' },
  view_finance_dashboard: { resource: 'reports', action: 'view' },
  view_finance_report: { resource: 'reports', action: 'view' },
  view_holiday: { resource: 'holidays', action: 'view' },
  view_hr_dashboard: { resource: 'reports', action: 'view' },
  view_immigration: { resource: 'employees', action: 'view' },
  view_income_expense_report: { resource: 'reports', action: 'view' },
  view_increment_promotion: { resource: 'employees', action: 'view' },
  view_invoice: { resource: 'invoices', action: 'view' },
  view_invoices: { resource: 'invoices', action: 'view' },
  view_lead: { resource: 'leads', action: 'view' },
  view_lead_agents: { resource: 'leads', action: 'view' },
  view_lead_category: { resource: 'leads', action: 'view' },
  view_lead_files: { resource: 'leads', action: 'view' },
  view_lead_follow_up: { resource: 'leads', action: 'view' },
  view_lead_note: { resource: 'leads', action: 'view' },
  view_lead_proposals: { resource: 'leads', action: 'view' },
  view_lead_report: { resource: 'reports', action: 'view' },
  view_lead_sources: { resource: 'leads', action: 'view' },
  view_leave: { resource: 'leaves', action: 'view' },
  view_leave_report: { resource: 'reports', action: 'view' },
  view_leaves_taken: { resource: 'employees', action: 'view' },
  view_message: { resource: 'messages', action: 'view' },
  view_miroboard: { resource: 'projects', action: 'view' },
  view_notice: { resource: 'notices', action: 'view' },
  view_order: { resource: 'orders', action: 'view' },
  view_overview_dashboard: { resource: 'reports', action: 'view' },
  view_payments: { resource: 'payments', action: 'view' },
  view_product: { resource: 'products', action: 'view' },
  view_project: { resource: 'projects', action: 'view' },
  view_project_budget: { resource: 'projects', action: 'view' },
  view_project_burndown_chart: { resource: 'projects', action: 'view' },
  view_project_dashboard: { resource: 'reports', action: 'view' },
  view_project_discussions: { resource: 'projects', action: 'view' },
  view_project_estimates: { resource: 'projects', action: 'view' },
  view_project_expenses: { resource: 'projects', action: 'view' },
  view_project_files: { resource: 'projects', action: 'view' },
  view_project_gantt_chart: { resource: 'projects', action: 'view' },
  view_project_hourly_rates: { resource: 'projects', action: 'view' },
  view_project_invoices: { resource: 'projects', action: 'view' },
  view_project_members: { resource: 'projects', action: 'view' },
  view_project_milestones: { resource: 'projects', action: 'view' },
  view_project_note: { resource: 'projects', action: 'view' },
  view_project_orders: { resource: 'orders', action: 'view' },
  view_project_payments: { resource: 'projects', action: 'view' },
  view_project_rating: { resource: 'projects', action: 'view' },
  view_project_tasks: { resource: 'projects', action: 'view' },
  view_project_template: { resource: 'projects', action: 'view' },
  view_project_timelogs: { resource: 'projects', action: 'view' },
  view_projects: { resource: 'projects', action: 'view' },
  view_sales_report: { resource: 'reports', action: 'view' },
  view_shift_roster: { resource: 'shift', action: 'view' },
  view_shift_schedule: { resource: 'shift', action: 'view' },
  view_sub_tasks: { resource: 'tasks', action: 'view' },
  view_task: { resource: 'tasks', action: 'view' },
  view_task_category: { resource: 'tasks', action: 'view' },
  view_task_comments: { resource: 'tasks', action: 'view' },
  view_task_files: { resource: 'tasks', action: 'view' },
  view_task_notes: { resource: 'tasks', action: 'view' },
  view_task_report: { resource: 'reports', action: 'view' },
  view_tasks: { resource: 'tasks', action: 'view' },
  view_ticket_dashboard: { resource: 'reports', action: 'view' },
  view_tickets: { resource: 'tickets', action: 'view' },
  view_time_log_report: { resource: 'reports', action: 'view' },
  view_timelog_earnings: { resource: 'tasks', action: 'view' },
  view_timelogs: { resource: 'tasks', action: 'view' },
  view_unassigned_tasks: { resource: 'tasks', action: 'view' },
};

/** استنتاج ماژول از pathname فرانت */
export const resolveRouteModule = (path) => {
  if (!path) return undefined;
  if (path.startsWith('/action')) return null;
  if (path.startsWith('/login') || path.startsWith('/register') || path.startsWith('/forgot-password')) {
    return null;
  }
  if (path.startsWith('/settings/superadmin')) return null;
  if (path.match(/^\/settings\/(packages|companies|superadmin|support-tickets)/)) return null;

  const normalized = path.replace(/\/\d+\//g, '/:id/').replace(/\/\d+$/, '/:id');
  if (ROUTE_MODULE_MAP[normalized] !== undefined) {
    return ROUTE_MODULE_MAP[normalized];
  }
  const sorted = Object.keys(ROUTE_MODULE_MAP).sort((a, b) => b.length - a.length);
  for (const prefix of sorted) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return ROUTE_MODULE_MAP[prefix];
    }
  }
  return undefined;
};

export const RESOURCE_MODULE_MAP = {
  leads: 'leads',
  clients: 'clients',
  products: 'products',
  orders: 'orders',
  tasks: 'tasks',
  projects: 'projects',
  tickets: 'tickets',
  callcenter: 'callcenter',
  notices: 'notices',
  messages: 'messages',
  invoices: 'invoices',
  payments: 'payments',
  events: 'events',
  employees: 'employees',
  leaves: 'leaves',
  attendance: 'attendance',
  holidays: 'holidays',
  shift: 'shift',
  expenses: 'expenses',
  bankaccount: 'bankaccount',
  estimates: 'estimates',
  deals: 'leads',
  contracts: 'contracts',
  reports: 'reports',
  settings: null,
};

/** نوع زیرمنو برای فیلتر داشبورد */
export const inferMenuItemAction = (permissionName) => {
  if (!permissionName) return 'view';
  if (permissionName.startsWith('add_')) return 'add';
  if (permissionName.startsWith('manage_')) return 'manage';
  if (permissionName.startsWith('edit_')) return 'edit';
  if (permissionName.startsWith('delete_')) return 'delete';
  return 'view';
};
